<template>
  <v-navigation-drawer
    v-model="infoSidebar"
    fixed
    right
    width="480"
  >
    <v-toolbar flat color="white">
      <v-btn icon @click="$emit('closeInfoSidebar')">
        <v-icon color="grey darken-2">mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title
        class="font-weight-regular grey--text text--darken-2"
      >
        Informações
      </v-toolbar-title>
    </v-toolbar>

    <v-layout column class="pa-4">
      <v-layout class="mb-2 px-2" align-center justify-space-between>
        <v-flex xs2 class="body-2 grey--text text--darken-1">DocGo</v-flex>
        <v-flex xs8 class="body-2 grey--text text--darken-1">Nº {{ doc.docflow_number }}</v-flex>

        <v-menu open-on-click top :close-on-content-click="false" z-index="300">
          <v-chip
            slot="activator"
            small
            color="grey darken-1"
            class="text-uppercase white--text font-weight-bold">
            Versão {{ last(doc.document_versions).version_number }}
          </v-chip>
          <v-card dark max-width="500">
            <span>ID: {{doc.id}} DocumentVersionID: {{last(doc.document_versions).id}} </span>
          </v-card>

        </v-menu>
      </v-layout>

      <v-divider/>

      <v-card flat class="mt-3">
        <v-card-text>
          <v-layout justify-center align-end style="position: relative">
            <v-icon class="mr-2">{{ fileStateIcon(doc.mime_type) }}</v-icon>
            <v-tooltip
              class="subheading text-truncate"
              top
              z-index="999"
              max-width="500"
            >
              <span slot="activator">{{ doc.document_type.name }}</span>
              <span>{{ doc.document_type.name }}</span>
            </v-tooltip>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="editDocument"
            v-if="canEdit"
            flat
            color="blue darken-1"
          >
            Editar
          </v-btn>
          <remove-document-dialog v-if="canRemove" :doc="doc"/>
          <unlink-document-dialog v-if="canUnlink" :doc="doc"/>

          <v-spacer/>
        </v-card-actions>
      </v-card>

      <v-menu
        open-on-hover
        z-index="999"
        top
        full-width
        offset-y
        v-if="!isEmpty(doc.activity_logs)"
      >
        <v-card
          slot="activator"
          class="my-3"
          flat
          color="grey lighten-3"
          width="430"
        >
          <v-card-text>
            <v-layout align-center justify-center>
              <v-flex xs6>
                <v-layout column>
                  <span class="body-1 grey--text text--darken-2">Última alteração</span>
                  <span class="body-2 grey--text text--darken-2">
                    {{lastUpdate}}
                  </span>
                </v-layout>
              </v-flex>

              <v-flex xs6>
                <v-layout>
                  <v-avatar class="mr-2" size="24">
                    <img :src="last(doc.activity_logs).user.avatar.url"/>
                  </v-avatar>
                  <span
                    class="body-2 grey--text text--darken-2 font-weight-bold"
                  >
                    {{capitalizeText(last(doc.activity_logs).user.name)}}
                  </span>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-card dark flat>
          <v-card-text>
            <v-layout column class="mb-2">
              <span class="body-2 grey--text text--lighten-2">Criado em:</span>
              <v-layout>
                <v-icon size="16" class="mr-2">mdi-calendar-range</v-icon>
                <span>{{ createdAt }}</span>
              </v-layout>
            </v-layout>
            <v-layout>
              <v-avatar size="24" class="mr-2">
                <img :src="doc.created_by.avatar.url"/>
              </v-avatar>
              <v-layout column>
                <span class="body-2">
                  {{capitalizeText(doc.created_by.name)}}
                </span>
                <span class="body-1">{{ doc.created_by.role.name}}</span>
              </v-layout>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-menu>

      <document-signers
        :doc="doc"
      />

      <v-layout column class="my-3">
        <div class="body-2 grey--text text--darken-1 mb-2 px-2">Processo do Documento</div>
        <v-layout class="pa-2 folder-container" :style="{'border-color': colors.grey.lighten2}">
          <span class="folder-type-border" :style="{'border-left-color': colors.grey.lighten2}">&nbsp;</span>
          <v-icon color="amber" class="mr-3" medium>mdi-folder-open</v-icon>
          <v-layout column>
            <strong class="grey--text text--darken-2 folder-id">{{ folder.process_number }}</strong>
            <div>{{ folder.folder_type.name }}</div>
          </v-layout>
        </v-layout>
      </v-layout>

      <v-layout column class="my-3">
        <div class="body-2 grey--text text--darken-1 mb-2 px-2">Entidade</div>
        <v-flex xs6 class="font-weight-bold grey--text text--darken-2">
          <v-chip color="grey lighten-3">
            <v-avatar size="24" color="white">
              <v-icon color="grey">mdi-briefcase</v-icon>
            </v-avatar>
            {{folder.entity.name}}
          </v-chip>
        </v-flex>
      </v-layout>
    </v-layout>

  </v-navigation-drawer>
</template>

<script>
import {last, lowerCase, startCase, isEmpty} from 'lodash';
import colors from 'vuetify/es5/util/colors';
import format from 'date-fns/format';
import {isBefore} from 'date-fns';
import * as ptLocale from 'date-fns/locale/pt';
import UnlinkDocumentDialog from '@/components/document/show/UnlinkDocumentDialog';
import RemoveDocumentDialog from '@/components/document/show/RemoveDocumentDialog';
import fileStateIcon from '@/mixins/file-state-icon';
import DocumentSigners from '@/components/document/show/DocumentSigners';

export default {
  name: 'DocumentInfo',
  components: {
    DocumentSigners,
    RemoveDocumentDialog,
    UnlinkDocumentDialog,
  },
  props: {
    doc: {
      type: Object,
      default: () => {
      },
    },
    infoSidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colors,
      isEmpty,
      last,
      format,
      fileStateIcon,
    };
  },
  methods: {
    closeDocumentInfo() {

    },
    capitalizeText(string) {
      const lowerCaseText = lowerCase(string);
      return startCase(lowerCaseText);
    },
    editDocument() {
      this.$router.push(`/pastas/${ this.folder.id }/documentos/${ this.doc.id }`);
    },
  },
  computed: {
    folder() {
      console.log(this.$store.getters.activeFolder);
      return this.$store.getters.activeFolder;
    },
    user() {
      return this.$store.getters.user;
    },
    canEdit() {
      return (this.user.id === this.doc.created_by.id || this.user.id === this.folder.current_owner.id) &&
        this.doc.mime_type === 'application/pdf' &&
        this.doc.document_state.state !== 'DocGo' &&
        this.doc.document_state.enum !== 'unlinked';
    },
    canRemove() {
      return (this.user.id === this.doc.created_by.id || this.user.id === this.folder.current_owner.id) &&
        this.doc.mime_type === 'application/pdf' &&
        this.doc.document_state.enum !== 'unlinked' &&
        (this.doc.document_state.state !== 'DocGo' ||
          (this.doc.document_state.state === 'DocGo' && this.isLastDocument && this.wasNotSent));
    },
    canUnlink() {
      return this.doc.document_state.state === 'DocGo' &&
        this.doc.document_state.enum !== 'unlinked' &&
        this.user.super_admin;
    },
    lastUpdate() {
      const lastLog = last(this.doc.activity_logs);
      const lastUpdate = last(lastLog.logs);
      const lastUpdateDay = format(lastUpdate.updated_at, 'DD');
      const lastUpdateMonth = startCase(format(lastUpdate.updated_at, 'MMMM', {locale: ptLocale}));
      const lastUpdateYear = format(lastUpdate.updated_at, 'YYYY');
      return `${ lastUpdateDay } de ${ lastUpdateMonth } de ${ lastUpdateYear }`;
    },
    createdAt() {
      const createdAtDay = format(this.doc.created_at, 'DD');
      const createdAtMonth = startCase(format(this.doc.created_at, 'MMMM', {locale: ptLocale}));
      const createdAtYear = format(this.doc.created_at, 'YYYY');
      return `${ createdAtDay } de ${ createdAtMonth } de ${ createdAtYear }`;
    },
    wasNotSent() {
      const documentCreation = this.doc.created_at;
      let lastFolderTransaction = {};
      if (!isEmpty(this.doc.transactions)) {
        lastFolderTransaction = last(this.folder.transactions).created_at;
      } else {
        return true;
      }
      return isBefore(documentCreation, lastFolderTransaction);
    },
    isLastDocument() {
      return this.doc.id === last(this.folder.documents).id;
    },
  },
};
</script>

<style scoped>
  .folder-container {
    border: 1px solid;
    border-radius: 3px;
    position: relative;
  }

  .folder-type-border {
    position: absolute;
    height: 100%;
    left: -1px;
    top: 0px;
    border-radius: 3px 0 0 3px;
    border-left: 5px solid;
    transition: ease-in-out .15s;
  }
</style>



// WEBPACK FOOTER //
// src/components/document/show/DocumentInfo.vue